<template>
  <stories />
</template>

<script>
import Vue from 'vue'
import stories from '@/components/StoriesHome.vue'

export default {
  name: 'StoriesHome',
  components: {
    stories
  }
}
</script>
